// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-pane[data-v-419f68fc] {\n  margin-top: 1.4rem;\n}", ""]);
// Exports
module.exports = exports;
